import React from 'react';
import PropTypes from 'prop-types';

const NextTitleViewView = ({ nextTitle, isInSummaryEdit, isLastViewOnDeck }) => {
  if (isInSummaryEdit && isLastViewOnDeck) {
    return <div>Back to Summary</div>;
  }
  if (nextTitle) {
    return <div>{nextTitle}</div>;
  }
  return (
    <div>
      Next Question
      <i className="adv-workflow-navigation-next-button-i fa fa-arrow-right" />
    </div>
  );
};
NextTitleViewView.propTypes = {
  nextTitle: PropTypes.string.isRequired,
  isInSummaryEdit: PropTypes.bool.isRequired,
  isLastViewOnDeck: PropTypes.bool.isRequired,
};

export default NextTitleViewView;
